(ns manage.adset.view.menu
  (:require [common.advertiser.hooks :refer [use-demo-advertiser]]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.adset :as q]
            [common.widgets.menu :as context-menu]
            [manage.adset.hooks :as h]
            [measure.report-builder.hooks :as report-builder.h]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal confirm-delete :adset/confirm-delete
  [{:keys [on-confirm]}]
  [deletion-confirmation
   {:on-submit on-confirm
    :entity-name "Adset"
    :confirmation-message
    "Your adset has no published version. When you delete this adset, there is no way back. Are you sure you want to delete it?"}])

(defhook use-adset-base-menu-items [{:keys [archived workflow] :as adset}]
  (let [{:keys [campaign-id adset-id] :as url-context} (use-subscribe [:url-context])
        delete-adset? (h/use-can-delete-adset?)

        rules-workflow? (= workflow "rules")

        {delete-adset :mutate} (use-mutation (q/delete-adset-mutation {:campaign-id campaign-id}))
        {patch-adset :mutate} (use-mutation (q/patch-adset-mutation {:adset-id adset-id}))

        on-delete-success (fn []
                            (rfe/navigate :campaign/page {:path-params url-context}))]
    (cond-> [{:label "Edit"
              :on-click #(rf/dispatch [:modal/open {:id :adset/edit
                                                    :props {:adset adset}}])}
             {:label "Duplicate"
              :disabled? (not rules-workflow?)
              :on-click #(rf/dispatch [:ocp/open {:id :adset/duplicate}])}
             {:label (if archived
                       "Un-archive"
                       "Archive")
              :on-click (fn []
                          (if archived
                            (patch-adset {:archived false})
                            (rf/dispatch [:modal/open
                                          {:id :confirm-archive
                                           :props {:on-confirm (fn []
                                                                 (patch-adset
                                                                  {:archived true}
                                                                  #js {:onSuccess #(rf/dispatch [:modal/close])}))
                                                   :type "adset"}}])))}]
      delete-adset?
      (conj {:label "Delete"
             :on-click #(rf/dispatch [:modal/open
                                      {:id :adset/confirm-delete
                                       :props {:on-confirm (fn []
                                                             (delete-adset
                                                              {:id (:id adset)}
                                                              #js {:onSuccess on-delete-success}))}}])}))))

(defui menu [adset]
  (let [items (use-adset-base-menu-items adset)
        url-context (use-subscribe [:url-context])
        synced-with-hogarth-adset? (h/use-synced-with-hogarth?)
        {:keys [is-demo]} (use-demo-advertiser)]
    ($ context-menu/menu
       {:icon "more_vert"
        :items (cond-> items
                 synced-with-hogarth-adset?
                 (conj {:label "Edit ad variants"
                        :href (rfe/href :adset/ad-variants-creation url-context)})

                 (and (#{"ad-variants"} (:workflow adset))
                      (#{"display" "video" "ctv"} (:channel adset)))
                 (conj {:label "Generate tags"
                        :disabled? is-demo
                        :on-click #(rf/dispatch [:export-tags/open-ocp :html-file [(:id adset)]])})

                 (contains? report-builder.h/allowed-channels (:channel adset))
                 (conj {:label "Generate report"
                        :href (rfe/href :advertiser/reports url-context {:new-report true
                                                                         :adset-id (:id adset)
                                                                         :channel (:channel adset)})}))})))
